import { Feature, FeatureCollection, Geometry, Point, Polygon } from "geojson";
import { ColorType } from "./color-type";
import { Tempo } from "./tempo";
import { TipoAnalise } from "src/app/dashboard/models/analise";
import { HeatmapType } from "./heatmap-type";


export interface MapConfig {

  routed: boolean;

  /** */
  details: MapConfigDetails;

  /** Configurações do tempo. */
  time: TimeConfig;

  /** Configurações de exibição das camadas. */
  layer: LayerConfig;
  
  /** Dados geográficos das chuvas. */
  geoData: GeometryData;

  /** Configurações do filtro dos dados. */
  dataFilter: FilterConfig;
}

/**  */
export class MapConfigDetails {

  /**
   * 
   * @param id id da análise
   * @param projectId id do projeto
   * @param analysisType tipo de análise
   * @param name nome da análise
   */
  constructor(
    public analysisId: number,
    public projectId: number,
    public analysisType: TipoAnalise,
    public analysisName: string
  ) {}
}


/** Configurações do tempo. */
export class TimeConfig {
  
  /**
   * 
   * @param enabledRealTime 
   * @param startDate 
   * @param startTime 
   * @param endDate 
   * @param endTime 
   * @param eventIntervalInHours
   * @param eventIntervalInMinutes 
   */
  constructor(
    public enabledRealTime: boolean,
    public newSearch: boolean,
    public tempo: Tempo[],
    public startDate: string,
    public startTime: string,
    public endDate: string,
    public endTime: string,
    public eventIntervalInHours: number,
    public eventIntervalInMinutes: number,
    ) { }

  get startDatetime() {
    return `${this.startDate} ${this.startTime}`;
  }

  get endDatetime() {
    return `${this.endDate} ${this.endTime}`;
  }
}

/** Configurações das camadas. */
export class LayerConfig {

  /**
   * 
   * @param tilesizeInKm 
   * @param percentile 
   * @param colors 
   * @param isActive 
   */
  constructor(
    public tilesizeInKm: number,
    public percentile: number[],
    public list?: LayerItem[],
  ) {}
}

/** */
export interface LayerItem {
  type: HeatmapType,
  color: ColorType,
  isActive: boolean,
}

/** Dados geométricos das chuvas. */
export class GeometryData {

  /**
   * 
   * @param selectedColumn
   * @param stations 
   * @param filteredStations 
   * @param middleIndicesPluv 
   * @param polygons
   */
  constructor(
    public selectedColumn: string,
    public stations: FeatureCollection<Point>,
    public filteredStations: FeatureCollection<Point>,
    public middleIndicesPluv: number[],
    public polygons: Feature<Geometry>[],
  ) {}
}

/** Dados dos filtros da fonte dos dados e porcentagem de completude. */
export class FilterConfig {

  /** Fonte de dados selecioonada pelo usuário */
  dataSource: string[];

  /**
   * 
   * @param dataSourceOptions Fonte dos dados (PREFEITURA NITERÓI, CEMADEN, ou ambos).
   * @param completeness Porcentagem de completude dos acumulados de chuva.
   */
  constructor(
    public dataSourceOptions: {text: string, value: string[]}[],
    public completeness: number,
  ) {
    this.dataSource = this.dataSourceOptions[0].value;
  }
}
